import { render, staticRenderFns } from "./fixed-assets.vue?vue&type=template&id=39f7aad2&scoped=true"
import script from "./fixed-assets.vue?vue&type=script&lang=js"
export * from "./fixed-assets.vue?vue&type=script&lang=js"
import style0 from "./fixed-assets.vue?vue&type=style&index=0&id=39f7aad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7aad2",
  null
  
)

export default component.exports